<template>
  <div class="">
    <!-- <div class="app_title size-14">
      <div class="app_web">
        <i class="iconfont icon-shouye size-14"></i>
        <a href="" class="app_web_link" target="_blank">{{
          $t("common_pageText.WEBSITEHOME")
        }}</a>
      </div>
      <div class="app_welcomeInfo">
        <span class="welcome_info"
          >{{ $t("common_pageText.HELLO") }}
          <div class="app_user">{{ description }}</div>
          {{ $t("common_pageText.WELCOMEMSG") }}</span
        >
        <a class="" v-if="false">{{
          $t("common_pageText.WELCOMEMSG_NOLOGIN")
        }}</a
        >&nbsp;&nbsp;&nbsp;&nbsp;
        <a class="app_logout" @click="logout">{{
          $t("common_pageText.LOGOUT")
        }}</a>
        &nbsp;&nbsp;
        <div class="app_lang">
          <button
            type="button"
            class="lang_btn size-14"
            :class="language == 'EN' ? 'active' : ''"
            @click="changeLang('EN')"
          >
            Eng</button
          >|
          <button
            type="button"
            class="lang_btn size-14"
            :class="language == 'ZH' ? 'active' : ''"
            @click="changeLang('ZH')"
          >
            简</button
          >|
          <button
            type="button"
            class="lang_btn size-14"
            :class="language == 'ZHT' ? 'active' : ''"
            @click="changeLang('ZHT')"
          >
            繁
          </button>
        </div>
      </div>
    </div> -->
    <slot></slot>
  </div>
</template>
<script>
// import { mapGetters } from "vuex";

export default {
  inject: ["reload"],
  computed: {
    // ...mapGetters("user", ["description", "fileUserImgBase64", "language"])
  },
  methods: {
    // changeLang(lang) {
    //   let _this = this;
    //   _this.$store.commit("user/setLanguage", lang);
    //   _this.$i18n.locale = lang;
    //   _this.reload();
    // },
    // logout() {
    //   let _this = this;
    //   _this.$store.dispatch("user/removeUser");
    //   _this.$router.replace("login?langcode=" + _this.$i18n.locale);
    // }
  }
};
</script>
<style scoped>
/* .app_logout {
  color: #999;
} */
.app_welcomeInfo {
  display: flex;
  align-items: center;
}
.welcome_info {
  display: flex;
  align-items: center;
}
/* .app_lang {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: auto 80px auto 20px;
}
.lang_btn,
.lang_btn:hover,
.lang_btn:focus,
.lang_btn:active {
  border: none;
  background: none;
  cursor: pointer;
  outline: none;
}
.lang_btn:hover,
.lang_btn.active {
  color: #a50606;
  font-weight: 700;
} */
</style>


